<div *ngIf="toggled && showMinimize" class="jmCollapseTitleLearnMore" [ngClass]="{ 'jmEmptyWidget' : noDataWidget && highlightNoData}">
	<table id="{{componentId}}" class="w-100 h-100" style="table-layout:fixed;">
		<tr><td class="jmPageTitle text-truncate">
				{{objectName}}
			</td>
			<td class="text-end jmWidgetControlContainer" style="width:30px;">
				<div role="button" (click)="toggleCollapse()" class="icnSquarePlus text-primary" [ngClass]="{'jmEmptyWidget' : noDataWidget && highlightNoData }"></div>
			</td>
		</tr>
	</table>
</div>

<div *ngIf="!toggled" id="{{componentId}}" class="h-100 jmWidgetPadding" [ngClass]="{ 'jmEmptyWidget' : noDataWidget && highlightNoData}">
	<table class="w-100">
		<tr>
			<td class="jmPageTitle">
				{{objectName}} 
			</td>
			<td class="text-end text-nowrap align-text-top jmWidgetControlContainer" style="cursor:default">
				<ng-container *ngIf="!showMinimize">
					<ng-container *ngFor="let action of secondaryActions">
						<i *ngIf="action.icon.length > 0" (click)="clickAction(action)" [hidden]="!getActionStatus()" role="button" class="text-primary {{action.icon}}" ngbTooltip="{{action.toolTip}}" container="body" placement="bottom" style="vertical-align: middle; margin-right: 10px;"></i>
						<div *ngIf="action.html.length > 0" (click)="clickAction(action)" [hidden]="!getActionStatus()" role="button" ngbTooltip="{{action.toolTip}}" container="body" placement="bottom" class="d-inline-block" style="margin-right: 10px;" [innerHTML]="action.html"></div>
					</ng-container>
				</ng-container>
				<ng-container *ngFor="let action of actions">
					<i *ngIf="action.icon.length > 0" (click)="clickAction(action)" [hidden]="!getActionStatus()" role="button" class="text-primary {{action.icon}}" ngbTooltip="{{action.toolTip}}" container="body" placement="bottom" style="vertical-align: middle; margin-right: 10px;"></i>
					<div *ngIf="action.html.length > 0" (click)="clickAction(action)" [hidden]="!getActionStatus()" role="button" ngbTooltip="{{action.toolTip}}" container="body" placement="bottom" class="d-inline-block" style="margin-right: 10px;" [innerHTML]="action.html"></div>
				</ng-container>
				<div *ngIf="showMinimize" role="button" (click)="toggleCollapse()" [ngClass]="isPopup?'jmCloseBtn':'icnSquareMinus text-primary'" style="display: inline;"></div>
			</td>
		</tr>
		<tr *ngIf="showMinimize && secondaryActions.length > 0">
			<td colspan="2" class="text-end">
				<ng-container>
					<ng-container *ngFor="let action of secondaryActions">
						<i *ngIf="action.icon.length > 0" (click)="clickAction(action)" [hidden]="!getActionStatus()" role="button" class="text-primary {{action.icon}}" ngbTooltip="{{action.toolTip}}" container="body" placement="bottom" style="vertical-align: middle; margin-right: 10px;"></i>
						<div *ngIf="action.html.length > 0" (click)="clickAction(action)" [hidden]="!getActionStatus()" role="button" ngbTooltip="{{action.toolTip}}" container="body" placement="bottom" class="d-inline-block" style="margin-right: 10px;" [innerHTML]="action.html"></div>
					</ng-container>
				</ng-container>
			</td>
		</tr>
	</table>

	<div *ngIf="retrievingData" class="d-flex align-items-center justify-content-center w-100 h-100">
		<span class="jmWidgetLoadingIcon40"></span>
	</div>

	<div *ngIf="!retrievingData && noDataWidget" class="d-flex align-items-center justify-content-center w-100 h-100">
		<div [innerHTML]="noDataMessage | safe:'html'" (click)="clickNoDataMessage($event)"></div>
	</div>

	<table *ngIf="!retrievingData && !noDataWidget" style="margin-top: 20px;" class="jmTableHeight">
		<tr class="h-100">
			<td>
				<div *ngIf="objectItems!=null && objectItems.length > 0" class="jmCarousel">
					<ngb-carousel #myCarousel appCarouselNoWrap class="h-100" (slide)="onSlide($event)">
						<ng-template ngbSlide *ngFor="let s of slides; let outerIndex=index" id="{{outerIndex}}">
							<div *ngIf="(outerIndex===slides.length-1 && !downloadComplete) || resizing" class="d-flex align-items-center justify-content-center w-100 h-100">
								<span class="jmWidgetLoadingIcon40"></span>
							</div>
							<div *ngIf="(outerIndex < slides.length-1  || downloadComplete) && !resizing" [ngClass]="showMinimize?'row':'row h-100'">
								<div *ngFor="let item of objectItems | slice:(s*itemsPerSlide):(s+1)*itemsPerSlide; let innerIndex=index;" [ngClass]="showMinimize?'col-12':'col-4 h-100'" style="margin-bottom: 5px;">
									<div class="border h-100" style="padding:10px;">
										<app-territory-card [normalizedData]="item" [displayMode]="displayMode" (onFollowToggled)="followToggled($event, outerIndex*itemsPerSlide+innerIndex, outerIndex)"></app-territory-card>
									</div>
								</div>
							</div>
						</ng-template>
					</ngb-carousel>
				</div>
				<div *ngIf="(objectItems==null || objectItems.length === 0) && resultMessage.length > 0">
					<div [innerHTML]="resultMessage | safe:'html'"></div>
				</div>
			</td>
		</tr>
	</table>
</div>
